import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { connect, useDispatch } from 'react-redux'
import i18n from 'i18next'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// components
import CreateAlertButton from '../crear-alerta-button'
import { FiltersMobile } from '../filters/filter-screen'

// mixins
import { CreateAlertContainer } from './mixins'

// store
import { resetListadoAvisosStore } from '../../../../redux/actions/listado-avisos'
import { setFilterSettings } from '../../../../redux/actions/filters'

import { makeURL, parseURL } from '../../../../utils/search-avisos-v2'

/**
 * Traduce los nombres de los filtros
 */
const translateFilterNames = (filters: any[]) => {
  if (!filters) {
    return filters
  }
  return filters.map((filter: { facets: any[] }) => {
    return {
      ...filter,
      facets: filter.facets.map((facet: { name: any }) => {
        return { ...facet, name: i18n.t(`filtros.${facet.name}`, { defaultValue: facet.name }) }
      }),
    }
  })
}

/**
 * Traduce los nombres de los filtros cuando están aplicados
 */
const translateFiltersApplied = (filtersApplied: any[]) => {
  if (!filtersApplied) {
    return filtersApplied
  }
  return filtersApplied.map((filter: { name: any }) => {
    return { ...filter, name: i18n.t(`filtros.${filter.name}`, { defaultValue: filter.name }) }
  })
}

const CreateAlertSection = ({ match, filters, filtersApplied, filtersSettings }) => {
  const { isMobile, isTabletPortrait } = useWindowSize()
  const dispatch = useDispatch()

  useEffect(() => {
    filtersApplied &&
      filtersApplied.map(item => {
        if (item.id === 'query') {
          dispatch(resetListadoAvisosStore())
          dispatch(setFilterSettings())
        }
      })
  }, [filtersApplied])

  const isOnlyDefaultApplied =
    filtersSettings &&
    filtersApplied &&
    filtersApplied.length === 1 &&
    filtersApplied.some(
      (f: { id: any; type: any }) =>
        f.id === filtersSettings?.defaultFiltersApplied?.option?.value &&
        f.type === filtersSettings?.defaultFiltersApplied?.name
    )

  return isMobile || isTabletPortrait ? (
    <CreateAlertContainer>
      <CreateAlertButton />
      <FiltersMobile
        routerMatch={match}
        urlService={{ parseURL, makeURL }}
        allFilters={translateFilterNames(filters)}
        allAppliedFilters={translateFiltersApplied(filtersApplied)}
        deleteAll={!!filtersApplied && !isOnlyDefaultApplied}
        {...(filtersSettings && { filterSettings: filtersSettings.filters })}
        {...(filtersSettings && { defaultFilters: filtersSettings.defaultFiltersApplied })}
      />
    </CreateAlertContainer>
  ) : (
    <CreateAlertButton />
  )
}

const CreateAlertSectionWithRoute = withRouter(CreateAlertSection)

const states = ({ filtersStore, listadoAvisosStore, locationsStore }) => ({
  filtersSettings: filtersStore.filtersSettings,
  loadingAvisos: listadoAvisosStore.loading,
  opened: locationsStore && locationsStore.opened,
  locations: locationsStore && locationsStore.locations,
  ...filtersStore,
})

export default connect(states)(CreateAlertSectionWithRoute)
